import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import AuthPageShell from "../components/AuthPageShell";

const RAW_API_BASE = process.env.REACT_APP_API_URL || "";
const API_BASE = RAW_API_BASE.replace(/\/+$/, "").replace(/\/api$/, "");

export default function VerifyEmail() {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState("loading");
    const [message, setMessage] = useState("Подтверждаем email...");
    const token = searchParams.get("token") || "";

    useEffect(() => {
        if (!token) {
            setStatus("error");
            setMessage("Ссылка подтверждения некорректна: отсутствует токен.");
            return;
        }

        let cancelled = false;

        async function verifyEmail() {
            try {
                const res = await fetch(`${API_BASE}/api/verify?token=${encodeURIComponent(token)}`, {
                    method: "GET",
                    credentials: "include",
                });
                await res.json().catch(() => ({}));

                if (cancelled) {
                    return;
                }

                if (!res.ok) {
                    setStatus("error");
                    setMessage("Ссылка подтверждения недействительна или срок ее действия истек.");
                    return;
                }

                setStatus("success");
                setMessage("Email подтвержден. Теперь можно войти в аккаунт.");
            } catch (error) {
                if (!cancelled) {
                    setStatus("error");
                    setMessage("Не удалось подтвердить email. Проверьте соединение и попробуйте снова.");
                }
            }
        }

        verifyEmail();

        return () => {
            cancelled = true;
        };
    }, [token]);

    return (
        <AuthPageShell>
            <h1 className="auth-page-title">Подтверждение email</h1>

            {status === "loading" ? (
                <p className="auth-verify-status auth-verify-status--loading">{message}</p>
            ) : (
                <p className={`auth-verify-status ${status === "success" ? "form-message--success" : "form-message"}`}>
                    {message}
                </p>
            )}

            {status === "success" && (
                <div className="auth-links">
                    <Link to="/login" className="btn-outline">Войти</Link>
                </div>
            )}
            {status === "error" && (
                <div className="auth-links">
                    <Link to="/register" className="btn-outline">Зарегистрироваться заново</Link>
                </div>
            )}
        </AuthPageShell>
    );
}
